import {useEffect, useRef} from 'react';

type FunctionArgument = () => void;

export const useOnMount = (func?: FunctionArgument) => {
  const didMountRef = useRef(false);

  // eslint-disable-next-line eag/no-effect-without-cleanup
  useEffect(() => {
    if (didMountRef.current === false) {
      func?.();
      didMountRef.current = true;
    }
  }, []);
};
